/**
 * BrewNectar Social Proof — auto-scroll marquee, manual arrows, video cards
 */
(function () {
  'use strict';

  var CDN_FALLBACK_SCROLL = 340;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getTransformX(el) {
    var style = window.getComputedStyle(el);
    if (!style.transform || style.transform === 'none') return 0;
    var matrix = new DOMMatrixReadOnly(style.transform);
    return matrix.m41;
  }

  function initFadeUp(section) {
    var animated = section.querySelectorAll('.bn-sp__animate');

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      animated.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var rootMargin = section.getAttribute('data-bn-sp-observer-margin') || '-60px 0px';
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: rootMargin, threshold: 0 }
    );

    animated.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initCarousel(section) {
    var track = section.querySelector('[data-bn-sp-track]');
    if (!track) return;

    var scrollAmount = parseInt(section.getAttribute('data-bn-sp-scroll-amount'), 10) || CDN_FALLBACK_SCROLL;
    var autoScroll = section.getAttribute('data-auto-scroll') === 'true';
    var arrows = section.querySelectorAll('[data-bn-sp-arrow]');

    if (prefersReducedMotion()) {
      section.setAttribute('data-auto-scroll', 'false');
      track.classList.add('is-paused');
    }

    arrows.forEach(function (button) {
      button.addEventListener('click', function () {
        var direction = button.getAttribute('data-bn-sp-arrow');
        if (!direction) return;

        track.classList.add('is-manual', 'is-paused');
        track.style.animation = 'none';

        var current = getTransformX(track);
        var delta = direction === 'left' ? scrollAmount : -scrollAmount;
        track.style.transform = 'translateX(' + (current + delta) + 'px)';
      });
    });

    if (!autoScroll) {
      track.classList.add('is-paused');
    }
  }

  function initVideoCard(card) {
    var stage = card.querySelector('[data-bn-sp-video-stage]');
    var video = card.querySelector('video');
    var muteBtn = card.querySelector('[data-bn-sp-mute]');
    if (!stage || !video) return;

    var playIcon = stage.querySelector('[data-bn-sp-icon-play]');
    var pauseIcon = stage.querySelector('[data-bn-sp-icon-pause]');
    var muteOnIcon = card.querySelector('[data-bn-sp-icon-muted]');
    var muteOffIcon = card.querySelector('[data-bn-sp-icon-unmuted]');

    function setPlaying(playing) {
      stage.classList.toggle('is-playing', playing);
      if (playIcon) playIcon.hidden = playing;
      if (pauseIcon) pauseIcon.hidden = !playing;
    }

    function setMuted(muted) {
      video.muted = muted;
      if (muteOnIcon) muteOnIcon.hidden = !muted;
      if (muteOffIcon) muteOffIcon.hidden = muted;
    }

    setMuted(true);

    stage.addEventListener('click', function () {
      togglePlayback();
    });

    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        togglePlayback();
      }
    });

    function togglePlayback() {
      if (video.paused) {
        video.play().then(function () {
          setPlaying(true);
        }).catch(function () {
          setPlaying(false);
        });
      } else {
        video.pause();
        setPlaying(false);
      }
    }

    video.addEventListener('ended', function () {
      setPlaying(false);
    });

    if (muteBtn) {
      muteBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        setMuted(!video.muted);
      });
    }
  }

  function initSection(section) {
    if (!section || section.dataset.bnSpInit === 'true') return;
    section.dataset.bnSpInit = 'true';

    initFadeUp(section);
    initCarousel(section);
    section.querySelectorAll('[data-bn-sp-video-card]').forEach(initVideoCard);
  }

  function initAll() {
    document.querySelectorAll('.bn-sp').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.bn-sp');
    if (section) initSection(section);
  });
})();
